import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { API } from 'aws-amplify'
import { Link } from 'react-router-dom'
import queryString from 'query-string'
import _ from 'lodash'
import moment from 'moment'
import AliceCarousel from 'react-alice-carousel'
import { POST_PAGE } from '../../utils/lottoList'
import { getLang } from '../../redux/selectors/lang'
import { getAuth } from '../../redux/selectors/auth'
import Flare1 from '../../components/Flare/Flare1'
import Flare2 from '../../components/Flare/Flare2'
import { fetchLottos } from '../../redux/actions/lottos'
import './Lottos.scss'
import YeekeeModal from './components/YeekeeModal'
import 'react-alice-carousel/lib/alice-carousel.css'
import { LOTTO_GROUP_ENG, LOTTO_GROUP_TH } from '../../utils/lottoList'

// 🔹 Toggle แสดง/ซ่อนหวย 12 นักษัตร
const SHOW_ZODIAC = false // true = แสดง, false = ซ่อน

// ====================== Slide Show Mobile ======================
let listOfMobileImages = []
class SlideshowMobile extends React.Component {
  importAll(r) {
    return r.keys().map(r)
  }
  componentWillMount() {
    listOfMobileImages = this.importAll(
      require.context('../../assets/dong-banner/mobile/', false, /\.(png|jpe?g|svg)$/),
    )
  }
  render() {
    return (
      <div className='home mobile' style={{ marginBottom: '10px' }}>
        <AliceCarousel buttonsDisabled={true} dotsDisabled={true} autoPlay autoPlayInterval={5000} mouseTracking>
          {listOfMobileImages.map((each, index) => (
            <img key={index} className='home__sliderimg' src={each} alt='slide' />
          ))}
        </AliceCarousel>
      </div>
    )
  }
}

// ====================== Slide Show PC ======================
let listOfPcImages = []
class SlideshowPc extends React.Component {
  importAll(r) {
    return r.keys().map(r)
  }
  componentWillMount() {
    listOfPcImages = this.importAll(
      require.context('../../assets/dong-banner/pc/', false, /\.(png|jpe?g|svg)$/),
    )
  }
  render() {
    return (
      <div className='home desktop container mx-auto mb-5'>
        <AliceCarousel buttonsDisabled={true} dotsDisabled={true} autoPlay autoPlayInterval={5000} mouseTracking>
          {listOfPcImages.map((each, index) => (
            <img key={index} className='home__sliderimg' src={each} alt='slide' />
          ))}
        </AliceCarousel>
      </div>
    )
  }
}

// ====================== Lotto Icon List ======================
const LOTTO_LIST = [
  { title: 'หวยรัฐบาลไทย', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'ฮานอย พิเศษ', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย เที่ยง', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย สตาร์', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'เวียดนาม พิเศษ', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'เวียดนาม', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'เวียดนาม VIP', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย VIP', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย HD', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย TV', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย กาชาด', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย EXTRA', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย รอบดึก', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'ฮานอย สตาร์', src: require('../../assets/lotto-flags/vietnam-flag.png') },
  { title: 'มาเลเซีย', src: require('../../assets/lotto-flags/malaysia-flag.png') },
  { title: 'ลาว พัฒนา', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว สตาร์', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาวสตาร์ VIP', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว จำปาศักดิ์', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว HD', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาวดาว', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว TV', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว VIP', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว กาชาด', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาวดิจิตอล', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว เวียงจันทร์', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ลาว สามัคคี', src: require('../../assets/lotto-flags/laos-flag.png') },
  { title: 'ดาวโจนส์ VIP', src: require('../../assets/lotto-flags/usa-flag.png') },
  { title: 'ดาวโจนส์', src: require('../../assets/lotto-flags/usa-flag.png') },
  { title: 'นิเคอิ รอบเช้า', src: require('../../assets/lotto-flags/japan-flag.png') },
  { title: 'ไทย รอบเช้า', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'ไทย รอบเช้าตลาด', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'จีน รอบเช้า', src: require('../../assets/lotto-flags/china-flag.png') },
  { title: 'ฮั่งเส็ง รอบเช้า', src: require('../../assets/lotto-flags/hongkong-flag.png') },
  { title: 'ไทยเที่ยง', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'ไต้หวัน', src: require('../../assets/lotto-flags/taiwan-flag.png') },
  { title: 'นิเคอิ รอบบ่าย', src: require('../../assets/lotto-flags/japan-flag.png') },
  { title: 'เกาหลี', src: require('../../assets/lotto-flags/korean-flag.png') },
  { title: 'จีน รอบบ่าย', src: require('../../assets/lotto-flags/china-flag.png') },
  { title: 'ไทย รอบบ่าย', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'ฮั่งเส็ง รอบบ่าย', src: require('../../assets/lotto-flags/hongkong-flag.png') },
  { title: 'ไทย รอบบ่ายตลาด', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'สิงคโปร์', src: require('../../assets/lotto-flags/singapore-flag.png') },
  { title: 'ไทย เย็น', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'อินเดีย', src: require('../../assets/lotto-flags/india-flag.png') },
  { title: 'อียิปต์', src: require('../../assets/lotto-flags/egypt-flag.png'), title_en: 'Egypt' },
  { title: 'ไทยกลางคืน', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'รัสเซีย', src: require('../../assets/lotto-flags/russia-flag.png') },
  { title: 'อังกฤษ', src: require('../../assets/lotto-flags/uk-flag.png') },
  { title: 'เยอรมัน', src: require('../../assets/lotto-flags/german-flag.png') },
  { title: 'หวยรัฐบาลไทย', src: require('../../assets/lotto-flags/thailand-flag.png') },
  { title: 'หวยออมสิน', src: require('../../assets/lotto-flags/bank-gsb.png') },
  { title: 'หวยธกส.', src: require('../../assets/lotto-flags/tks.png') },
  { title: 'นิเคอิ(เช้า) VIP', src: require('../../assets/lotto-flags/japan-flag.png') },
  { title: 'จีน(เช้า) VIP', src: require('../../assets/lotto-flags/china-flag.png') },
  { title: 'ฮั่งเส็ง(เช้า) VIP', src: require('../../assets/lotto-flags/hongkong-flag.png') },
  { title: 'ไต้หวัน VIP', src: require('../../assets/lotto-flags/taiwan-flag.png') },
  { title: 'นิเคอิ(บ่าย) VIP', src: require('../../assets/lotto-flags/japan-flag.png') },
  { title: 'เกาหลี VIP', src: require('../../assets/lotto-flags/korean-flag.png') },
  { title: 'จีน(บ่าย) VIP', src: require('../../assets/lotto-flags/china-flag.png') },
  { title: 'ฮั่งเส็ง(บ่าย) VIP', src: require('../../assets/lotto-flags/hongkong-flag.png') },
  { title: 'สิงคโปร์ VIP', src: require('../../assets/lotto-flags/singapore-flag.png') },
  { title: 'รัสเซีย VIP', src: require('../../assets/lotto-flags/russia-flag.png') },
  { title: 'อังกฤษ VIP', src: require('../../assets/lotto-flags/uk-flag.png') },
  { title: 'เยอรมัน VIP', src: require('../../assets/lotto-flags/german-flag.png') },
  { title: '2D รอบเช้า', src: require('../../assets/lotto-flags/2d-flag.png') },
  { title: '2D รอบบ่าย', src: require('../../assets/lotto-flags/2d-flag.png') },
  { title: '2D รอบเย็น', src: require('../../assets/lotto-flags/2d-flag.png') },
]

// ====================== ฟังก์ชันเช็ควันหวย ======================
const checkIsLottoSameDate = (lottos = null) => {
  if (_.isEmpty(lottos)) {
    return false
  }
  const shouldShow = _.some(lottos, (item) => {
    if (item.lottoGroup === 'หวยไทย') {
      return item.status === 'open' // 👈 แสดงเสมอถ้าสถานะเปิด
    }

    const newDrawDateStr = item.drawDateStr.replace(/\//g, '-')
    const drawDateTime = moment(newDrawDateStr + ' ' + item.drawTimeStr, 'DD-MM-YYYY HH:mm:ss')
    const timeToCheck = moment(drawDateTime).subtract(item.openMinutesBeforeDraw - 1, 'minutes')

    if (item.lottoName === 'ดาวโจนส์' || item.lottoName === 'ดาวโจนส์ VIP') {
      return timeToCheck.isSame(moment().subtract(10, 'hours'), 'day')
    }

    return timeToCheck.isSame(moment(), 'day')
  })
  return shouldShow
}

// ====================== Main Component ======================
export default function Lottos({ location }) {
  const [isLoaded, setIsLoaded] = useState(false)
  const dispatch = useDispatch()
  const { twoAbove, twoBelow, threeStraight } = queryString.parse(location.search)
  const auth = useSelector(getAuth)
  const lang = useSelector(getLang)
  const language = lang.lang

  const lottos = useSelector((state) => state).lottos.lottos
  const lottosItemsGroupByType = _.groupBy(lottos, 'lottoGroup')
  const forSort = _.keysIn(lottosItemsGroupByType)

  // 🔹 เพิ่มสิบสองนักษัตรไว้ในลำดับ แต่จะซ่อนด้วย SHOW_ZODIAC
  const sortLotto = ['หวยแนะนำ', 'หวยไทย', 'หวยวีไอพี', 'หวยหุ้น', 'หวยยี่กี', 'สิบสองนักษัตร']
  const lottosTypes = sortLotto.filter((el) => {
    if (!SHOW_ZODIAC && el === 'สิบสองนักษัตร') return false
    return forSort.indexOf(el) >= 0 && !_.isEmpty(lottosItemsGroupByType[el])
  })

  const [showYeekeeModal, setShowYeekeeModal] = useState({ isShow: false, data: {} })
  // ====================== Fetch Lottos + สร้างหวยแนะนำ ======================
  // ====================== Fetch Lottos + สร้างหวยแนะนำ ======================
  useEffect(() => {
    setIsLoaded(false)
    API.get('lotto', '/lottos?limit=600')
      .then(({ detail }) => {
        const todayLottos = detail
        let recommend = []

        // ดึงข้อมูลสำหรับ "หวยแนะนำ" เหมือนโค้ดเดิม
        Promise.all([
          API.get('lotto', '/lottos?status=open&lottoGroup=สิบสองนักษัตร&limit=1'),
          API.get('lotto', '/lottos?status=open&lottoGroup=หวยยี่กี&limit=1'),
          API.get('lotto', '/lottos?status=open&lottoGroup=หวยวีไอพี&limit=1'),
          API.get('lotto', '/lottos?status=open&lottoGroup=หวยไทย&limit=1'),
          API.get('lotto', '/lottos?status=open&lottoGroup=หวยหุ้น&limit=1'),
        ]).then(([zodiac, yeekee, vip, thai, stock]) => {
          const addRecommend = (data, index) => {
            if (data.length > 0) {
              const newGroup = data.map((el) => [{ ...el, lottoGroup: 'หวยแนะนำ', index }])
              if (['open', 'closed', 'rewarded'].includes(newGroup[0][0].status)) {
                recommend.push(newGroup[0][0])
              }
            }
          }

          addRecommend(zodiac.detail, 5)
          addRecommend(yeekee.detail, 4)
          addRecommend(vip.detail, 3)
          addRecommend(thai.detail, 2)
          addRecommend(stock.detail, 1)

          const sortData = recommend.sort((a, b) => (a.index > b.index ? 1 : -1))
          dispatch(fetchLottos(todayLottos.concat(sortData)))
        })
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoaded(true))
  }, [twoAbove, twoBelow, threeStraight, dispatch])
  if (!lottos) return <p>loading...</p>


  // ====================== Component Lotto ======================
  const Lotto = (props) => {
    const [diffTime, setDiffTime] = useState('loading...')
    const [isBlock, setIsBlock] = useState(false)
    const realDrawTimeMoment = moment(props.closeDateTimeRealMoment, 'DD-MM-YYYY HH:mm:ss')
    const [imageUrl, setImageUrl] = useState(require('../../assets/lotto-flags/dong.png'))
    const [errorImageUrl, setErrorImageUrl] = useState(false)

    useEffect(() => {
      const differ = realDrawTimeMoment.diff(moment())
      let myInterval
      const createInverval = (drawTimeMoment) => {
        const updateTime = (drawTimeMoment) => {
          const differ = drawTimeMoment.diff(moment())
          let withOutDate = moment.utc(differ).format('HH:mm:ss')
          setDiffTime(withOutDate)
          if (differ <= 0) clearInterval(myInterval)
        }
        myInterval = setInterval(() => updateTime(drawTimeMoment), 1000)
      }
      if (parseInt(differ) < 0) {
        setIsBlock(true)
      } else {
        createInverval(realDrawTimeMoment)
      }
      return () => clearInterval(myInterval)
    }, [])

    const _onImageUrlError = () => {
      if (!errorImageUrl) {
        setImageUrl(require('../../assets/lotto-flags/dong.png'))
        setErrorImageUrl(true)
      }
    }

    return (
      <Link
        to={props.lottoName.split(' ')[1] !== 'นักษัตร' ? '/lottos/' + props.lottoNumber : '/zodiac'}
        className={`lottos__item ${isBlock && props.lottoName.split(' ')[1] !== 'นักษัตร'
          ? 'blocked'
          : auth.username
            ? ''
            : 'notAuthenticated'
          }`}
      >
        <Flare1 />
        <Flare2 />
        <div className='lottos__item-header'>
          <img
            src={
              props.lottoName.split(' ')[1] === 'นักษัตร'
                ? require('../../assets/zodiac/mini-star/เถาะ.png') // ใช้รูปเดียว
                : props.lottoName.slice(0, 5) === 'ดองยี'
                  ? require('../../assets/lotto-flags/dong.png')
                  : LOTTO_LIST.find((o) => o.title === props.lottoName)?.src
            }
            onError={_onImageUrlError}
            alt='lotto icon'
          />
          <div>
            <div>{props.lottoName.slice(0, 5) === 'ดองยี' ? `${language === 'MM' ? 'ရီကီထီ ဒေါင်း ' : 'ดองยี่กี '}${props.lottoName.split(' ')[1]}` : (language === 'MM' ? POST_PAGE[props.lottoName] : props.lottoName)}</div>

            <div>close {moment(props.closeDateTimeRealMoment).format('HH:mm')}</div>
          </div>
        </div>
        <div className='lottos__item-timer'>
          <img src={require('./assets/clock.svg')} alt='clock' />
          <img className='lottos__item-block-icon' src={require('./assets/blocked.png')} alt='lotto icon' />
          {auth.username ? (
            <div>{isBlock ? 'close' : diffTime}</div>
          ) : (
            // <div style={{ color: 'red', fontSize: '12px' }}>กรุณาเข้าสู่ระบบ</div>
            <div style={{ color: 'red', fontSize: '12px' }}>Please log in to proceed</div>
          )}
        </div>
      </Link>
    )
  }

  // ====================== Render Lotto ======================
  const RenderLotto = (props) => {
    const lottos = props.lottos
    const activeLottos = []
    const inactiveLottosWithSameDate = []

    if (!_.isEmpty(lottos)) {
      lottos.forEach((item) => {
        const newDrawDateStr = item.drawDateStr.replace(/\//g, '-')
        const drawDateTime = moment(newDrawDateStr + ' ' + item.drawTimeStr, 'DD-MM-YYYY HH:mm:ss')
        const differ = drawDateTime.diff(moment())
        const timeToCheck = moment(drawDateTime).subtract(item.openMinutesBeforeDraw - 1, 'minutes')
        const isSameDate = item.lottoGroup === 'หวยไทย'
          ? true // 👈 หวยไทยแสดงตลอด
          : timeToCheck.isSame(moment(), 'day')
        const isPassed = parseInt(differ) < 0
        const closeDateTimeRealMoment = moment(drawDateTime).subtract(item.closeMinutesBeforeDraw, 'minutes')

        if (isSameDate && !isPassed) {
          activeLottos.push(
            <Lotto
              key={item.lottoNumber + item.lottoName}
              lottoNumber={item.lottoNumber}
              lottoName={item.lottoName}
              drawDateStr={item.drawDateStr}
              drawTimeStr={item.drawTimeStr}
              imageUrl={item.imageUrl}
              closeMinutesBeforeDraw={item.closeMinutesBeforeDraw}
              closeDateTimeRealMoment={closeDateTimeRealMoment}
            />,
          )
        } else if (isSameDate && isPassed) {
          inactiveLottosWithSameDate.push(
            <Lotto
              key={item.lottoNumber + item.lottoName}
              lottoNumber={item.lottoNumber}
              lottoName={item.lottoName}
              drawDateStr={item.drawDateStr}
              drawTimeStr={item.drawTimeStr}
              imageUrl={item.imageUrl}
              closeMinutesBeforeDraw={item.closeMinutesBeforeDraw}
              closeDateTimeRealMoment={closeDateTimeRealMoment}
              lottoGroup={item.lottoGroup}
              status={item.status}
            />,
          )
        }
      })
    }

    return [...activeLottos, ...inactiveLottosWithSameDate]
  }

  return (
    <div className='lottos page mt-20'>
      <SlideshowMobile />
      <SlideshowPc />
      {!isLoaded && <div className='loading-gif'></div>}
      {lottosTypes.map((item, index) => {
        const lottosInGroup = lottosItemsGroupByType[item] || []
        if (_.isEmpty(lottosInGroup)) return null // 👈 กันอีกชั้น
        const shouldShow = checkIsLottoSameDate(lottosInGroup)
        if (!shouldShow) return null

        return (
          <section key={index}>
            <div className='dong_lottos__header container text-4xl mt-10'>
              <h1>
                {language === 'MM'
                  ? LOTTO_GROUP_ENG[item] || item
                  : LOTTO_GROUP_TH[item] || item}
              </h1>
            </div>
            <div className='lottos__list container'>
              {isLoaded ? (
                !_.isEmpty(lottosItemsGroupByType[item]) ? (
                  <RenderLotto lottos={lottosItemsGroupByType[item]} />
                ) : null
              ) : (
                <div style={{ color: 'red' }}>loading...</div>
              )}
            </div>
          </section>
        )
      })}
      {showYeekeeModal.isShow ? (
        <YeekeeModal
          showModal={showYeekeeModal}
          setShowModal={setShowYeekeeModal}
          lottoNumber={showYeekeeModal.data.lottoNumber}
          lottoData={showYeekeeModal.data}
        />
      ) : null}
    </div>
  )
}

Lottos.propTypes = {
  location: PropTypes.object,
}